import { createTheme } from '@mui/material/styles';
import MuiTheme from '../theme';

export const inkTheme = createTheme(MuiTheme);
